import React from 'react';
import { Dropdown } from 'antd';
import { FiChevronDown } from 'react-icons/fi';
import { TbLoader2 } from 'react-icons/tb';
import classNames from 'classnames';

import { Button, buttonVariants } from '@/components/Button';
import styles from './SplitButton.module.scss';

/**
 * A primary action button with an optional attached chevron that opens a
 * menu of alternate actions (e.g. "Create Task" + "Create & Add Another").
 * With no `menuItems`, this is just `Button` unchanged — the composite
 * split shape only exists once there's a second action to attach it to.
 */
export const SplitButton = ({
  text,
  onClick,
  loading = false,
  disabled = false,
  variant = buttonVariants.primary,
  menuItems = [],
  ariaLabel = 'More actions',
}) => {
  if (!menuItems.length) {
    return (
      <Button
        text={text}
        onClick={onClick}
        loading={loading}
        disabled={disabled}
        variant={variant}
      />
    );
  }

  return (
    <div
      className={classNames(styles.splitButton, {
        [styles.splitButtonDisabled]: disabled || loading,
      })}
    >
      <button
        type="button"
        className={styles.mainSegment}
        onClick={onClick}
        disabled={disabled || loading}
      >
        {loading && <TbLoader2 className={styles.spinnerIcon} size={16} />}
        <span className={styles.mainSegmentText}>{text}</span>
      </button>
      <Dropdown
        trigger={['click']}
        disabled={disabled || loading}
        menu={{
          items: menuItems.map((item, index) => ({
            key: index,
            label: item.label,
            onClick: item.onClick,
          })),
        }}
      >
        <button
          type="button"
          className={styles.chevronSegment}
          aria-label={ariaLabel}
          disabled={disabled || loading}
        >
          <FiChevronDown size={14} />
        </button>
      </Dropdown>
    </div>
  );
};

SplitButton.displayName = 'SplitButton';
